<template>
  <div class="t-content-box">
    <div class="t-item-subtitle">
      <div class="title-num-content">
        {{ teamItemName }}（{{ teamItemCount }}{{ $t('message["929"]') }}）
        <a-dropdown v-if="groupSettingsBoolean&&(roleTeamEditGroup||roleTeamDeleteGroup)">
          <a class="ant-dropdown-link team-set">
            {{ $t('message["1334"]') }}
            <a-icon
              type="ellipsis"
              class="detail-icon"
            />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-if="roleTeamEditGroup && configGroupSetting">
              <a @click="handleGroupSet"> {{ $t('message["1337"]') }} </a>
            </a-menu-item>
            <a-menu-item v-if="roleTeamDeleteGroup">
              <a @click="handleDelete"> {{ $t('message["963"]') }} </a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <span
          v-if="teamSettingsBoolean&&roleTeamSetting"
          class="team-set"
          @click="handleTeamSet"
        >{{ $t('message["1230"]') }}</span>
      </div>
    </div>
    <div class="t-content-header">
      <a-button
        v-if="teamSettingsBoolean&&roleTeamAddGroup"
        class="t-button-group"
        @click="handleAddGroup"
      >
        {{ $t('message["1197"]') }}
      </a-button>
      <a-button
        v-if="(roleTeamAddMember||configGroupAddMember)"
        type="primary"
        class="t-button-primary"
        @click="handleAddMember"
      >
        {{ $t('message["1191"]') }}
      </a-button>
      <a-button
        v-if="(roleTeamInviteMember||configGroupInviteMember) && !$isDingDing"
        class="t-button-invite"
        @click="handleInvite"
      >
        {{ $t('message["1439"]') }}
      </a-button>
      <router-link
        v-if="groupMembersDetail.isdisplay === 1"
        class="t-button-set"
        :to="{name: 'configRule', query: {groupid: groupMembersDetail.groupid, roleid: groupMembersDetail.roleid, tab: 'setmethod'}}"
      >
        {{ $t('message["1036"]') }}
      </router-link>
    </div>
    <div class="main-content-table">
      <a-table
        :columns="columns"
        :data-source="tableDatas"
        :pagination="false"
        :loading="loading"
        :custom-header-row="expandAllHandler"
        class="main-content-table-list"
        row-key="userid"
      >
        <template
          slot="truename"
          slot-scope="truename, record"
        >
          <span class="truename-tit">{{ truename }}</span>
          <a-tag
            v-if="record.rolelevel"
            color="#4CA0F2"
          >
            {{ record.rolelevel }}
          </a-tag>
        </template>
        <template
          slot="roleinfos"
          slot-scope="key"
        >
          <span
            v-for="(item,index) in key"
            :key="index"
          >
            <a-tag :class="{roleManageBack:(item.system_role==='1'||item.system_role==='2')}">
              {{ item.rolename }}
            </a-tag>
          </span>
        </template>
        <template
          slot="groupInfos"
          slot-scope="key"
        >
          <span
            v-for="(items,indexs) in key"
            :key="indexs"
          >
            {{ items.rolename }}/{{ items.groupname }}；
          </span>
        </template>
        <template
          slot="operate"
          slot-scope="key"
        >
          <span
            class="member-manage-btn"
            @click="changMemberVisible({key,state:true})"
          >{{ $t('message["413"]') }} </span>
        </template>
        <div
          slot="filterDropdown"
          slot-scope="{}"
          class="custom-filter-dropdown"
        >
          <a-popover
            :visible="filterRShow"
            placement="bottomLeft"
            overlay-class-name="popover-filter-role"
          >
            <template slot="content">
              <div class="drop-down-box">
                <filter-roles-form
                  ref="filterRolesForm"
                  @filterFromHandler="filterFromHandler"
                />
              </div>
            </template>
            <!-- <span class="from-info-btn-pop">test</span> -->
          </a-popover>
        </div>
      </a-table>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import FilterRolesForm from './FilterRolesForm'
export default {
  components: {
    FilterRolesForm
  },
  data () {
    return {
      teamSettingsBoolean: false,
      groupSettingsBoolean: false,
      groupSettingsEdit: false,
      roleTeamSetting: false,
      roleTeamAddGroup: false,
      roleTeamAddMember: false,
      roleTeamInviteMember: false,
      roleTeamEditGroup: false,
      roleTeamDeleteGroup: false,
      configGroupSetting: false,
      configGroupAddMember: false,
      configGroupInviteMember: false,
      editGroupValue: '',
      editGroupValueLength: '',
      selectGroupId: '',
      loading: false,
      filtersparams: {}
    }
  },
  computed: {
    ...mapState('team/manage', ['permmissionLists', 'selectTreenDataId', 'isOtherGroup', 'isOtherRole', 'treeDefaultKey', 'roleId', 'tableDatas', 'treeDatas', 'teamItemName', 'teamItemCount', 'selectTreenDataKey', 'groupMembersDetail', 'isFilter']),
    ...mapState('team/member', ['filterRShow']),
    dingtalkStructureStatus () {
      return this.$store.state.baseinfo.dingtalk_structure_status
    },
    systemRole () {
      return this.$store.state.baseinfo.system_role * 1 === 1
    },
    upgradeTip () {
      return this.$t('message["168"]').split('|')
    },
    upgradeTip2 () {
      return this.$t('message["175"]').split('|')
    },
    isAll () {
      return !this.teamSettingsBoolean && !this.groupSettingsBoolean
    },
    columns () {
      const arr = [{
        title: this.$t('message["112"]'),
        dataIndex: 'truename',
        key: 'truename',
        width: 200,
        scopedSlots: { customRender: 'truename' }
      }, {
        title: this.$t('message["503"]'),
        dataIndex: 'roleinfo',
        key: 'roleinfo',
        width: 110,
        scopedSlots: { customRender: 'roleinfos',
          filterDropdown: 'filterDropdown'
        },
        filterIcon: <em class="anticon anticon-filter th-filter-icon"><i class="iconfont iconicon-test20"></i></em>,
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            this.setFilterRShow(true)
          } else {
            this.setFilterRShow(false)
          }
        }
      }, {
        title: this.$t('message["1159"]'),
        dataIndex: 'groupInfo',
        key: 'groupInfo',
        scopedSlots: { customRender: 'groupInfos' }
      }, {
        title: this.$t('message["79"]'),
        dataIndex: 'userid',
        key: 'userid',
        width: 100,
        scopedSlots: { customRender: 'operate' }
      }]
      const arr2 = [{
        title: this.$t('message["112"]'),
        dataIndex: 'truename',
        key: 'truename',
        width: 200,
        scopedSlots: { customRender: 'truename' }
      }, {
        title: this.$t('message["503"]'),
        dataIndex: 'roleinfo',
        key: 'roleinfo',
        width: 110,
        scopedSlots: { customRender: 'roleinfos'
        }
      }, {
        title: this.$t('message["1159"]'),
        dataIndex: 'groupInfo',
        key: 'groupInfo',
        scopedSlots: { customRender: 'groupInfos' }
      }, {
        title: this.$t('message["79"]'),
        dataIndex: 'userid',
        key: 'userid',
        width: 100,
        scopedSlots: { customRender: 'operate' }
      }]
      return this.isAll ? arr : arr2
    }
  },
  watch: {
    selectTreenDataKey (val) {
      if (val) {
        this.formateSelectkey(val)
      }
    },
    isOtherRole (val) {
      if (val) {
        this.teamSettingsBoolean = true
      }
    },
    isOtherGroup (val) {
      if (val) {
        this.groupSettingsBoolean = true
      }
    },
    teamItemName (val) {
      if (!val) return
      this.editGroupValue = val
    },
    permmissionLists (val) {
      if (val) {
        this.roleTeamSetting = val['role-team-setting']
        this.roleTeamAddGroup = val['role-team-add-group']
        this.roleTeamAddMember = val['role-team-add-member']
        this.roleTeamInviteMember = val['role-team-invite-member']
        this.roleTeamEditGroup = val['role-team-edit-group']
        this.roleTeamDeleteGroup = val['role-team-delete-group']
        this.configGroupSetting = val['config-group-setting']
        this.configGroupAddMember = val['config-group-add-member']
        this.configGroupInviteMember = val['config-group-invite-member']
        document.title = `${this.$t('message["1228"]')}-${this.$store.state.baseinfo.projectname}-${this.$store.state.baseinfo.comname}`
      }
    },
    isFilter (val) {
      if (!val) {
        this.filtersparams = {}
        this.$refs.filterRolesForm && this.$refs.filterRolesForm.resetForm()
      }
    }
    // tableDatas: {
    //   handler (val) {
    //     if (val && !this.isFilter) {
    //       this.filtersparams = {}
    //       this.$refs.filterRolesForm && this.$refs.filterRolesForm.resetForm()
    //     }
    //   },
    //   deep: true
    // }
  },
  mounted () {
    if (this.permmissionLists) {
      this.roleTeamSetting = this.permmissionLists['role-team-setting']
      this.roleTeamAddGroup = this.permmissionLists['role-team-add-group']
      this.roleTeamAddMember = this.permmissionLists['role-team-add-member']
      this.roleTeamInviteMember = this.permmissionLists['role-team-invite-member']
      this.roleTeamEditGroup = this.permmissionLists['role-team-edit-group']
      this.roleTeamDeleteGroup = this.permmissionLists['role-team-delete-group']
      this.configGroupSetting = this.permmissionLists['config-group-setting']
      this.configGroupAddMember = this.permmissionLists['config-group-add-member']
      this.configGroupInviteMember = this.permmissionLists['config-group-invite-member']
    }
    if (this.teamItemName) {
      this.editGroupValue = this.teamItemName
    }
    if (this.selectTreenDataKey) {
      this.formateSelectkey(this.selectTreenDataKey)
    }
    this.groupSettingsBoolean = false
    this.teamSettingsBoolean = false
    if (this.groupMembersDetail.isdisplay) {
      this.groupMembersDetail.isdisplay = 0
    }
  },
  beforeDestroy () {
    this.setIsOtherRole(false)
  },
  methods: {
    ...mapMutations('team/member', ['setAddMemberVisible', 'setFilterRShow']),
    ...mapMutations('team/group', ['setAddGroupVisible']),
    ...mapMutations('team/manage', ['setTeamSetVisible', 'setIsOtherRole']),
    ...mapActions('team/manage', ['fetchTeamMemberDatas', 'fetchGetTeamSetPermissionList', 'fetchGetTeamSetLeaderDatas', 'fetchProjectMemberDatas', 'changeTreeDefaultKey', 'changInviteMemberVisible', 'fetchTeamOrganizationDatas']),
    ...mapActions('team/group', ['setAddGroupLoading', 'changeGroupFinalLoading', 'fetchGetGroupMembers', 'fetchGetGroupSetPermissionDatas', 'fetchGetEnableMembers', 'changeGroupSetVisible', 'fetchDeleteGroup', 'fetchEditGroup']),
    ...mapActions('team/member', ['changMemberVisible', 'fetchAddmemberList', 'fetchGetRoles', 'getAddStructureList', 'serviceInfo']),
    // 邀请跳转操作
    async handleInvite () {
      if (this.systemRole) {
        const chain = await this.serviceInfo()
        chain.onSuccess(raw => {
          if (raw.user_limit * 1 === raw.user_num * 1) {
            this.inviteTipDia(raw)
          } else {
            this.changInviteMemberVisible(true)
          }
        })
          .fetch()
      } else {
        this.$message.error(this.$t('message["412"]'))
      }
    },
    async handleAddMember () {
      let tempv = []
      const json = {
        roleid: 0,
        groupid: 0
      }
      if (this.selectTreenDataKey) {
        if (this.selectTreenDataKey.indexOf('|') >= 0) {
          const groupArrs = this.selectTreenDataKey.split('|')
          const [roleInfo, groupInfo] = groupArrs
          const roleArr = roleInfo.split('-')
          const groupArr = groupInfo.split('-')
          json.roleid = roleArr[1]
          json.groupid = groupArr[1]
        } else {
          tempv = this.selectTreenDataKey.split('-')
        }
      } else {
        const [firstValue] = this.treeDefaultKey
        tempv = firstValue.split('-')
      }
      const [name, id] = tempv
      if (name === 'projectid') {
        json.roleid = 0
        json.groupid = 0
      } else if (name === 'roleid') {
        json.roleid = id
        json.groupid = 0
      }
      this.dingtalkStructureStatus ? await this.getAddStructureList(json) : await this.fetchAddmemberList(json)
      this.fetchGetRoles({ status: 1 })
    },
    handleGroupSet () {
      this.changeGroupFinalLoading(false)
      this.groupSettingsEdit = false
      this.changeGroupSetVisible(true)
      if (!this.selectTreenDataKey) return
      const groupArrs = this.selectTreenDataKey.split('|')
      // const [roleInfo, groupInfo] = groupArrs
      // const roleArr = roleInfo.split('-')
      const groupArr = groupArrs[1].split('-')
      this.fetchGetGroupMembers({ groupid: groupArr[1], type: 1 })
      // this.fetchGetGroupSetPermissionDatas({ roleid: roleArr[1] })
    },
    handleTeamSet () {
      if (!this.selectTreenDataKey) return
      const roleArr = this.selectTreenDataKey.split('-')
      // this.fetchGetTeamSetPermissionList({ roleid: roleArr[1] })
      this.fetchGetTeamSetLeaderDatas({ roleid: roleArr[1], leadertype: 'team' })
      // this.fetchGetTeamSetLeaderDatas({ roleid: roleArr[1] })
      this.setTeamSetVisible(true)
    },
    // 根据树中角色选中设置可操作界面状态
    formateSelectkey (key) {
      this.groupSettingsEdit = false
      if (key.indexOf('|') >= 0) {
        this.teamSettingsBoolean = false
        this.groupSettingsBoolean = true
        this.selectGroupId = key
      } else {
        const tempArr = key.split('-')
        const [name] = tempArr
        if (name === 'projectid') {
          this.teamSettingsBoolean = false
          this.groupSettingsBoolean = false
        } else if (name === 'roleid') {
          this.teamSettingsBoolean = true
          this.groupSettingsBoolean = false
        }
      }
    },
    // 添加小组弹出Dialog
    handleAddGroup () {
      this.setAddGroupLoading(false)
      this.setAddGroupVisible(true)
      this.fetchGetEnableMembers()
    },
    // 编辑小组信息操作
    handleGroupEdit () {
      this.groupSettingsEdit = true
    },
    // 小组信息input change事件
    handleGroupName (e) {
      this.editGroupValue = this.editGroupValue.substring(0, 8)
    },
    // 保存小组编辑
    handleEditGroup () {
      if (!this.selectTreenDataKey) return
      const groupArrs = this.selectTreenDataKey.split('|')
      const groupArr = groupArrs[1].split('-')
      const params = {
        groupname: this.editGroupValue,
        groupid: groupArr[1]
      }
      this.fetchEditGroup(params)
      this.groupSettingsEdit = false
    },
    // 取消小组信息编辑操作
    handleCancel () {
      this.groupSettingsEdit = false
    },
    // 删除小组操作--二次确认弹框
    handleDelete () {
      if (!this.selectGroupId) {
        return
      }
      const groupArrs = this.selectGroupId.split('|')
      const [roleInfo, groupInfo] = groupArrs
      const roleArr = roleInfo.split('-')
      const groupArr = groupInfo.split('-')
      const params = {
        groupid: groupArr[1],
        roleid: roleArr[1]
      }
      let content = this.$t('message["1336"]') + '？'
      const that = this
      this.$confirm({
        title: <div><a-tag>{that.editGroupValue}</a-tag>{ this.$t('message["480"]') }</div>,
        closable: true,
        iconType: 'exclamation-circle',
        content: content,
        okText: this.$t('message["915"]'),
        cancelText: this.$t('message["896"]'),
        onOk () {
          that.fetchDeleteThisGroup(params)
          // that.fetchDeleteGroup(params)
          // that.groupSettingsBoolean = false
        }
      })
    },
    async fetchDeleteThisGroup (params) {
      const that = this
      const chain = await that.fetchDeleteGroup(params)
      chain.onSuccess(res => {
        that.fetchTeamOrganizationDatas({ root: true })
        that.groupSettingsBoolean = false
        // dispatch('team/manage/fetchTeamOrganizationDatas', {}, { root: true })
      })
        .fetch()
    },
    inviteTipDia (val) {
      if (!val) return
      let text = ''
      let confirmText = ''
      if (val.vip === 0) {
        confirmText = this.$t('message["1050"]')
        text = `${this.upgradeTip[0]}${val.user_limit}${this.upgradeTip[1]}`
      } else if (val.vip === 1) {
        text = `${this.upgradeTip2[0]}${val.user_limit}${this.upgradeTip2[1]}`
        confirmText = this.$t('message["579"]')
      }
      const that = this
      this.$confirm({
        title: <div>{this.$t('message["1323"]')}</div>,
        closable: false,
        centered: true,
        content: text,
        iconType: 'exclamation-circle',
        okText: confirmText,
        cancelText: this.$t('message["896"]'),
        onOk () {
          // that.setAddMemberVisible(false)
          if (confirmText === that.$t('message["1050"]')) {
            that.$router.push({
              name: 'ServiceIndex'
            })
          } else if (confirmText === that.$t('message["579"]')) {
            that.$router.push({
              name: 'ServiceSuper'
            })
          }
        },
        onCancel () {
          // that.setAddMemberVisible(false)
        }
      })
    },
    filterFromHandler (val) {
      this.filtersparams = val
    },
    expandAllHandler (columns) {
      columns.forEach(item => {
        if (item.key === 'roleinfo') {
          const obj = Object.keys(this.filtersparams).length > 0 && this.filtersparams.roleid.length > 0
          item.customHeaderCell = (record) => {
            return {
              attrs: {
                'class': `ant-table-column-has-actions ant-table-column-has-filters ${obj ? 'filter-th-selected' : ''}`
              }
            }
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.t-content-box {
  width: 100%;
  margin-left: 40px;
  .detail-icon {
    transform: rotate(90deg);
    margin-right: -4px;
    cursor: pointer;
  }
  .t-content-header {
    clear: both;
    .t-button-primary {
      height: 32px;
      margin-bottom: 24px;
    }
    .t-button {
      margin-left: 12px;
      margin-bottom: 24px;
      width: 80px;
      height: 32px;
      border-radius: 4px;
      // box-shadow: inset 0 1px 1px 0 rgba(255, 255, 255, 0.5);
      border: solid 1px #5077aa;
      // background-image: linear-gradient(to top, #5077aa, #608fcc);
    }
    .t-button-invite {
      // width: 94px;
      height: 32px;
      border-radius: 4px;
      border: solid 1px #ebebeb;
      background-color: #f5f5f5;
      font-size: 14px;
      color: #333333;
      margin-bottom: 24px;
      &:hover {
        box-shadow: inset 0 2px 0 0 rgba(255, 255, 255, 0.5);
        border: solid 1px #ebebeb;
        background-color: #ffffff;
      }
    }
  }
}
.edit-group-content-div {
  width: 60%;
  margin-top: 12px;
  .edit-input-content {
    float: left;
    margin-bottom: 16px;
  }
  .edit-group-button {
    float: left;
    margin-left: 12px;
  }
}
.t-item-subtitle {
  padding: 10px 0px 15px 0px;
}
.member-manage-btn {
  color: #5077aa;
  cursor: pointer;
}
.team-set {
  color: #5077aa;
  cursor: pointer;
  float: right;
  vertical-align: middle;
}
.title-num-content {
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  border-bottom: solid 1px #ebebeb;
  width: 712px;
  margin-bottom: 12px;
}
.t-button-group {
  float: right;
  height: 32px;
  margin-right: 80px;
  border-radius: 4px;
  box-shadow: inset 0 2px 0 0 rgba(255, 255, 255, 0.5);
  border: solid 1px #ebebeb;
  background-color: #f5f5f5;
  font-size: 14px;
  color: #333333;
  margin-bottom: 24px;
  &:hover {
    box-shadow: inset 0 2px 0 0 rgba(255, 255, 255, 0.5);
    border: solid 1px #ebebeb;
    background-color: #ffffff;
  }
}
.color-background-666 {
  background-color: #666666;
}
.roleManageBack {
  background-color: #42c27e;
  color: white;
  border: none;
}
.main-content-table::v-deep {
  width: 712px;
  .filter-th-selected {
    .anticon-filter {
      color: #5077aa;
    }
  }
  .ant-table-thead > tr > th > .anticon-filter {
    // position: relative !important;
    top: -1px !important;
  }
}
.truename-tit {
  margin-right: 12px;
}
.t-button-set {
  float: right;
  padding: 10px 82px 0 0
}
.custom-filter-dropdown {
    margin: 10px 0 0  -69px;
  }
</style>
<style lang="scss">
   .popover-filter-role {
    width: 280px;
    padding-top: 0;
    .ant-popover-arrow {
      display: none;
    }
    .ant-popover-inner-content {
      padding: 20px 0 0;
    }
    .ant-popover-inner {
      position: relative;
    }
  }
</style>
